window.JobAPI = new (function () {
  var self = this;
  var _protected = BaseAPI.call(self);

  self.repostJob = function (jobId, atr_ids) {
    var deferred = $q.defer();
    var payload = {job_id: jobId};
      if (atr_ids) {
          payload.atr_ids = atr_ids;
      }
    _protected.request(`${self.apiUrl.replace('v1', 'v2')}jobs/repost`, 'PUT', payload).then((result) => {

      if (result?.data?.status_code === 200) {
        deferred.resolve({job_id: result.data.data});
      } else {
        deferred.reject({code: "IN_RE_POST"});
      }

    }, function (err) {
        if (err?.status === 412) {
            deferred.reject({code: "NO_CREDIT"});
        } else if(err?.data?.data){
            deferred.reject({code: "SERVER_ERROR", error: err.data.data});
        } else {
            deferred.reject(err);
        }
    });

    return deferred.promise;
  };

    self.getDistributorPaymentMethods = function (brandId) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/distributor_payment_methods", "GET")
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });


        return defer.promise;
    };

  self.boostJob = function (jobIds) {
    var deferred = $q.defer();
      _protected.request(`${self.apiUrl.replace('v1', 'v2')}jobs/extend`, 'POST', {job_ids: jobIds})
      .then(function (result) {

        if(result?.data?.status_code === 200) {
          deferred.resolve({job_id: jobIds});
        } else {
            deferred.reject({code: "IN_BOOST"});
        }
      }, function (err) {
          if (err?.status === 412) {
              deferred.reject({code: "NO_CREDIT"});
          } else if (err?.status === 400 && err.data.data) {
              deferred.reject({code: "SERVER_ERROR", error: err.data.data});
          } else {
              deferred.reject(err);
          }
      });

    return deferred.promise;
  };

    self.jobSwimLaneAppCount = function (jobId, laneId, param) {
        var defer = $q.defer();

        _protected.request('jobs/' + jobId + "/swimlanes/" + laneId + "/applicants/count", "GET", param)
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

  //Job Application form / Get job application form details
    self.getJobScreeningForm = function (jobId, formId) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId + '/screening_forms/' + formId, 'GET')
            .then(function (result) {
                if(result && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }

                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Create job screening form
    self.createJobScreeningForm = function (jobId, payload) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId + '/screening_forms', 'POST', payload)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    // Edit job screening form
    self.editJobScreeningForm = function (jobId, formId, payload) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId + '/screening_forms/' + formId, 'PUT', payload)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Delete job screening form
    self.deleteJobScreeningForm = function (jobId, formId) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId + '/screening_forms/' + formId, 'DELETE')
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Check Brand screening form name existence
    self.checkScreeningNameExistence = function (brandId, name) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/screening_forms/check', 'GET', {
            name: name
        }).then(function (result) {
            if (result.data && result.data.status_code == 200 && result.data.data) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Get Brand screening form
    self.getBrandScreeningForm = function (brandId, formId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/screening_forms/' + formId, 'GET').then(function (result) {
            if (result.data && result.data.status_code == 200 && result.data.data) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    // list all brand screening form templates
    self.loadBrandScreeningTemplates = function (brandId, type) {
        var deferred = $q.defer();

        var params = {};

        if (type) {
            params['type'] = type;
        }

        _protected.request('brands/' + brandId + '/screening_forms', 'GET', params)
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Get Job application details
    self.getJobApplicationDetails = function (jobApplicationId) {
        var deferred = $q.defer();

        _protected.request('job_applications/' + jobApplicationId, 'GET')
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Save/edit Job application options
    self.saveJobApplicationOptions = function (brandId, jobId, payload) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/jobs/' + jobId + '/application_options', 'PUT', payload)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.publish = function (jobId, templateId) {
        var deferred = $q.defer();

        var payload = {
            'job_id': jobId
        }

        _protected.request(`${self.apiUrl.replace('v1', 'v5')}jobs/publish`, 'PUT', payload)
            .then(function (result) {
                deferred.resolve(result);
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobBrands = function (groupId, isCreatingTemplate, templateId) {
        var deferred = $q.defer();
        var is_creating_template = !!isCreatingTemplate;

        if (templateId) {
            var params = {
                job_template_id: templateId
            };
        }

        _protected.request('groups/' + groupId + '/jobs/brands?is_template=' + is_creating_template, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobDetails = function (jobId, hasApplicants) {
        var deferred = $q.defer();
        var hasApplicants = !!hasApplicants;

        if (!jobId) {
            throw "No job id";
        }

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'jobs/' + jobId + '?has_applicants=' + hasApplicants, 'GET')
            .then(function (result) {
                deferred.resolve(result);
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobDetailsV3 = function (jobId, hasApplicants) {
        var deferred = $q.defer();
        var hasApplicants = !!hasApplicants;
        var includeCarriSettings = true;

        if (!jobId) {
            throw "No job id";
        }

        _protected.request(self.apiUrl.replace('v1', 'v3') + 'jobs/' + jobId + '?has_applicants=' + hasApplicants + '&include_carri_settings=' + includeCarriSettings, 'GET')
            .then(function (result) {
                deferred.resolve(result);
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.getSkills = function (positionId) {
        var deferred = $q.defer();

        if (!positionId) {
            positionId = 0;
        }

        _protected.request('jobs/allSkills/' +  positionId, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createJob = function (payload) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'jobs', 'POST', payload)
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateJob = function (payload, jobId) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'jobs/' + jobId, 'PUT', payload)
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.saveAsTemplate = function (jobId, templateName) {
        var deferred = $q.defer();

        if (!jobId) {
            throw "No job id";
        }

        var payload = {
            job_id: jobId,
            title: templateName
        }

        _protected.request('jobs/template', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobTiming = function (payload) {
        var deferred = $q.defer();

        _protected.request('jobs/timing', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteJobPost = function (jobId) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobCompensation = function (payload) {
        var deferred = $q.defer();

        _protected.request('jobs/compensation', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobDescription = function (payload) {
        var deferred = $q.defer();

        _protected.request('jobs/description', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobATS = function (payload) {
        var deferred = $q.defer();

        _protected.request('jobs/settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobExperience = function (jobId, experience, is_apprenticeship) {
        var deferred = $q.defer();

        var payload = {
            job_id: jobId,
            experience_from: experience
        };

        if (is_apprenticeship) {
            payload['is_apprenticeship'] = is_apprenticeship;
        }

        _protected.request('jobs/experience', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobSkills = function (jobId, skills) {
        var deferred = $q.defer();

        var payload = {
            job_id: jobId,
            skills: skills
        };

        _protected.request('jobs/skills', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    deferred.resolve(res);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Save/edit Job application assignees
    self.saveJobApplicationAssignees = function (brandId, jobId, asignees) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/assignees', 'PUT', asignees)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Save/edit Template enabled components
    self.saveTemplateEnabledComponents = function (jobId, payload) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId + '/enabled_components', 'PUT', payload)
            .then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Get job application options
    self.getJobApplicationOptions = function (brandId, jobId) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/jobs/' + jobId + '/application_options', 'GET')
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Get Job application documents
    self.getJobApplicationDocumentsStatus = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/application_documents', 'GET')
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Get Job application documents options
    self.getJobApplicationDocumentsOptions = function (jobId) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'jobs/' + jobId, 'GET')
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // Save job schedule
    self.saveJobSchedule = function (payload) {
        var deferred = $q.defer();

        _protected.request('jobs/schedule', 'PUT', payload)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Open Call
    self.getJobOpencall = function (jobId) {
        var deferred = $q.defer();

        _protected.request('jobs/'+jobId+'/open_calls', 'GET')
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createOpencall = function (jobId, payload) {
        var deferred = $q.defer();

        _protected.request('jobs/'+jobId+'/open_calls', 'POST', payload)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateOpencall = function (jobId, opencallId, payload) {
        var deferred = $q.defer();

        _protected.request('jobs/'+jobId+'/open_calls/' + opencallId, 'PUT', payload)
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteOpencall = function (jobId, opencallId) {
        var deferred = $q.defer();

        _protected.request('jobs/'+jobId+'/open_calls/' + opencallId, 'DELETE')
            .then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    //Get brand ATS template
    self.getBrandATSTemplate = function (brandId) {
        var deferred = $q.defer();

        _protected.request('ats_template/' + brandId, 'GET')
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteJobTemplate = function (templateId) {
        var deferred = $q.defer();

        _protected.request('jobs/' + templateId, 'DELETE')
            .then(function (result) {
                if (result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.applyTemplateToChildren = function (brandId, jobId, brands) {
        var deferred = $q.defer();

        var payLoad = {
            brands: []
        };

        for (var i in brands) {
            payLoad['brands'].push({
                id: brands[i].id,
                include_children: !!brands[i].include_children
            });
        }

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/apply_template', 'PUT', payLoad)
            .then(function (result) {
                if (result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobSettingsSection = function (brandId, jobId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings', 'GET')
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateAutoSkipApplicants = function (jobId, payload) {
        var deferred = $q.defer();

        _protected.request('/jobs/' + jobId + '/auto_skip_applicants', 'PUT', payload)
            .then(function (result) {
                if (result.data && result.data.status_code == 200 && result.data.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.canDeleteSwimlane =function (brandId, jobId, swimlaneName){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/swimlanes/' + swimlaneName + '/check_deletion', 'GET')
            .then(function (result) {
                if (result.data && result.data.data && result.data.status_code === 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }


    self.getJobsEmployers = function (brandId, positionCodes, categoryCodes, jobAccessMode) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject("No brand id");
        } else {

            var params = {
                position_code: positionCodes,
                category_code: categoryCodes,
                job_access_mode: jobAccessMode
            };
            _protected.request("brands/" + brandId + "/jobs/employers", "GET", params)
                .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    var jobSettingsPayload = {};

    self.updateJobSettingsSection = function (brandId, jobId, numberOfHires, evergeenAllowed, evergreenForced, customPeriodAllowed) {
        var deferred = $q.defer();

        var payload = {};
        payload['number_of_hires'] = numberOfHires;
        payload['evergreen_allowed'] = evergeenAllowed;
        payload['evergreen_forced'] = evergreenForced;
        payload['custom_period_allowed'] = customPeriodAllowed;

        jobSettingsPayload = $.extend(jobSettingsPayload, payload);

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings', 'PUT', jobSettingsPayload)
            .then(function (result) {
                if (result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.updateJobInterviewTypesSettings = function (brandId, jobId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings', 'PUT', payload)
            .then(function (result) {
                if (result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateJobSettings = function (brandId, jobId, payload) {
        var deferred = $q.defer();

        jobSettingsPayload = $.extend(jobSettingsPayload, payload);

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings', 'PUT', jobSettingsPayload)
            .then(function (result) {
                if (result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.toggleBrandEEOFormActivationStatus = function (brandId, formId, activationStatus) {

        var deferred = $q.defer();

        var payload = {
            empty: true
        };

        _protected.request('brands/' + brandId + '/screening_forms/' + formId + '/' + activationStatus, 'POST', payload)
            .then(function (result) {

                if (result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandEEOFormById = function (brandId, formId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/screening_forms/' + formId, 'GET')
            .then(function (result) {

                if (result && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createBrandEEOForm = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/screening_forms', 'POST', payload)
            .then(function (result) {

                if (result && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editBrandEEOForm = function (brandId, formId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/screening_forms/' + formId, 'PUT', payload)
            .then(function (result) {

                if (result && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandClassifications = function (brandId, brandIds) {

        var deferred = $q.defer();

        if (brandIds && brandIds.length) {
            var params = {
                brand_ids: brandIds
            };
        }

        _protected.request('brands/' + brandId + '/classifications', 'GET', params)
            .then(function (result) {

                if (result && result.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data.classifications || []);
                } else {
                    deferred.reject(result);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
});

JobAPI.ERROR_CODE = {
  NO_CREDIT: "NO_CREDIT",
  SERVER_ERROR: "SERVER_ERROR",
  IN_BOOST: "IN_BOOST",
  IN_RE_POST: "IN_RE_POST",
  WAGE_RULE_VIOLATION: "WAGE_RULE_VIOLATION"
};

JobAPI.JOB_POST_TYPES = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    BOTH: 'BOTH',
    PRIVATE_VIA_LINK: 'PRIVATE_VIA_LINK'
};
